<script setup>
defineProps({
  items: {
    type: Array,
    required: true
  }
})

const hasChildren = item => Array.isArray(item.children) && item.children.length > 0
</script>

<template>
  <v-list class="pa-0 rounded-0">
    <template
      v-for="(item, index) in items"
      :key="item.id"
    >
      <v-list-item
        :to="item.externalLink ? null : item.path"
        :href="item.externalLink || null"
        :target="item.externalLink ? '_blank' : null"
        :rel="item.externalLink ? 'noopener' : null"
        color="primary"
      >
        <v-list-item-title class="py-4 px-2">
          {{ item.title }}
        </v-list-item-title>

        <template
          v-if="hasChildren(item)"
          #append
        >
          <v-icon icon="$menu-right" />
          <span class="d-sr-only">
            Hat ein Untermenü. Kann mit "Pfeiltaste rechts" geöffnet werden.
          </span>
        </template>

        <v-menu
          v-if="hasChildren(item)"
          activator="parent"
          open-on-hover
          submenu
          :open-on-click="false"
          :open-on-focus="false"
        >
          <tree-menu :items="item.children" />
        </v-menu>
      </v-list-item>

      <v-divider v-if="index < items.length - 1" />
    </template>
  </v-list>
</template>
